import { POST_LOGOUT_SESSION_KEY } from "@/constants";
import {
  clearSessionFlag,
  hasSessionFlag,
  markSessionFlag,
} from "@/shared/auth/sessionFlag";

export function markPostLogoutSession(): void {
  markSessionFlag(POST_LOGOUT_SESSION_KEY);
}

export function isPostLogoutSession(): boolean {
  return hasSessionFlag(POST_LOGOUT_SESSION_KEY);
}

export function clearPostLogoutSession(): void {
  clearSessionFlag(POST_LOGOUT_SESSION_KEY);
}
